import React from 'react';
import InputField from '../../../components/inputs/inputField';
import TextAreaField from '../../../components/inputs/textAreaField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import EventSessionSurveys from './surveys';
import EventSessionSpeakers from './speakers';

class Application extends React.Component {
	render() {
		const {readOnly, updateSessionField, updatePolls, updateSpeakers, resetPoll, loadMoreAttendees, updateSession} = this.props;
		const { subtitle, description, pageOptions, pageId, displayStartTime, displayEndTime, displayTimezone, surveyOnly, enableReview, enableSurvey } = this.props.editedSession;
		const selectedPage = pageOptions.find(
			(po) => po._id.toString() == pageId && pageId.toString()
		) || { title: '', _id: null };

		return (
			<div className='sectionBody posRel mb-0 p-0 mt-20' >
				<InputField
					label={'Subtitle'}
					value={subtitle}
					disabled={readOnly}
					type="text"
					onChange={(e) => updateSessionField('subtitle', e.target.value)}
				/>
				<TextAreaField
					label={'Description'}
					value={description}
					disabled={readOnly}
					type="text"
					onChange={(e) => updateSessionField('description', e.target.value)}
				/>
				<SelectField
					label="Page Template"
					value={{ label: selectedPage.title, value: selectedPage._id }}
					name="Page Template"
					options={this.props.sessionsPages.map((po) => {
						return { label: po.label, value: po.value };
					})}
					onChange={(po) => updateSessionField('pageId', po.value)}
					disabled={readOnly}
				/>
				<div className="flex-sb w-100">
					<InputField
						label={'Display Start Time'}
						value={displayStartTime}
						disabled={readOnly}
						type="text"
						classes="mr-10 w-100"
						onChange={(e) => updateSessionField('displayStartTime', e.target.value)}
					/>

					<InputField
						label={'Display End Time'}
						value={displayEndTime}
						disabled={readOnly}
						type="text"
						classes="ml-10 w-100"
						onChange={(e) => updateSessionField('displayEndTime', e.target.value)}
					/>
				</div>
				<InputField
					label={'Display Timezone'}
					value={displayTimezone}
					disabled={readOnly}
					type="text"
					onChange={(e) => updateSessionField('displayTimezone', e.target.value)}
				/>

				<h4 className='blockHeader'>Features</h4>
				<ToggleField
					label="Hide from attendee agenda"
					checked={surveyOnly}
					icons={false}
					disabled={readOnly}
					onChange={(e) => updateSessionField('surveyOnly', !surveyOnly)}
				/>

				<ToggleField
					label="Enable Session Review"
					checked={enableReview}
					icons={false}
					disabled={readOnly}
					onChange={(e) => updateSessionField('enableReview', !enableReview)}
				/>
				<ToggleField
					label="Enable Survey"
					checked={enableSurvey}
					icons={false}
					disabled={readOnly}
					onChange={(e) => updateSessionField('enableSurvey', !enableSurvey)}
				/>

				<h4 className='blockHeader'>Speakers</h4>
				<div>
					<EventSessionSpeakers
						editedSession={this.props.editedSession}
						event={this.props.event}
						orgId={this.props.orgId}
						readOnly={readOnly}
						loadMoreAttendees={loadMoreAttendees}
						updateSession={updateSession}
						updateSpeakers={updateSpeakers}
					/>
				</div>
				<h4 className='blockHeader mt-0'>Survey Questions</h4>
				<div>
					<EventSessionSurveys
						editedSession={this.props.editedSession}
						event={this.props.event}
						orgId={this.props.orgId}
						readOnly={readOnly}
						loadMoreAttendees={loadMoreAttendees}
						updateSession={updateSession}
						updatePolls={updatePolls}
						resetPoll={resetPoll}
					/>
				</div>
			</div>
		);
	}
}

export default Application;
